import {
  ActivityFeedDomain,
  ActivityFeedSource,
} from '../../services/modules/activityFeed/activityFeed.types';
import { isDateOnlyYMD } from '../../utils/dates';

export const ACTIVITY_FEED_FILTER_SEARCH_PARAMS = {
  domain: 'domain',
  source: 'source',
  from: 'from',
  to: 'to',
} as const;

const ACTIVITY_FEED_DOMAINS: ActivityFeedDomain[] = [
  'registration',
  'orders',
  'order_status',
  'integration',
  'targets',
];

export const ORDER_ACTIVITY_FEED_DOMAINS: ActivityFeedDomain[] = ['order_status', 'integration'];

export const TARGET_ACTIVITY_FEED_DOMAINS: ActivityFeedDomain[] = ['targets'];

export const CUSTOMER_ACTIVITY_FEED_DOMAINS: ActivityFeedDomain[] = [
  'registration',
  'orders',
  'integration',
  'targets',
];

const ACTIVITY_FEED_SOURCES: ActivityFeedSource[] = [
  'web',
  'integration',
  'spreadsheet',
  'system',
  'automation',
  'rachel',
];

export const parseActivityFeedDomains = (values: string[]): ActivityFeedDomain[] | undefined => {
  const domains = ACTIVITY_FEED_DOMAINS.filter((domain) => values.includes(domain));

  return domains.length > 0 ? domains : undefined;
};

export const parseActivityFeedSource = (value: unknown): ActivityFeedSource | undefined =>
  ACTIVITY_FEED_SOURCES.find((source) => source === value);

export const parseActivityFeedDate = (value: unknown): string | undefined =>
  typeof value === 'string' && isDateOnlyYMD(value) ? value : undefined;
